import './styles.scss'

const InputArea = ({ title, error, required, maxLength, value = '', ...props }) => {
  return (
    <div className={`custom-input-area${error ? ' has-error' : ''}`}>
      <div className="label-row">
        <div className="label">
          {title}
          {required && <span className="required-mark"> *</span>}
        </div>
        {maxLength && (
          <span className={`char-count${value.length >= maxLength * 0.85 ? ' near-limit' : ''}`}>
            {value.length} / {maxLength}
          </span>
        )}
      </div>

      <textarea required={required} maxLength={maxLength} value={value} {...props} />

      {error && <span className="error-msg">{error}</span>}
    </div>
  )
}

export default InputArea
